export default __webpack_public_path__ + "static/lilypad-6237e073014d2ed3ea9ad27b3412345b.png";